/** 1 second in milliseconds */
export const oneSecondInMilliseconds = 1000;

/** 1 minute in milliseconds */
export const oneMinuteInMilliseconds = 60 * oneSecondInMilliseconds;

/** 1 hour in milliseconds */
export const oneHourInMilliseconds = 60 * oneMinuteInMilliseconds;

/** 1 day in milliseconds */
export const oneDayInMilliseconds = 24 * oneHourInMilliseconds;

/** 1 day in milliseconds */
export const oneWeekInMilliseconds = 7 * oneDayInMilliseconds;

/** 1 day in milliseconds */
export const oneWorkWeekInMilliseconds = 5 * oneDayInMilliseconds;
